import Pane from "components/Dashboards/General/Pane"
import Label from "components/General/Label"
import { Button } from "react-bootstrap"
import { formatGrade } from "shared/helpers/formatGrade"
import { AssessmentSubmissionResponse, LessonSubmissionResponse, TopicSubmissionResponse } from "shared/types/moduleTypes"
import { AssignmentSubmissionResponse } from "shared/types/studentTypes"
import styles from "./studentSubmission.module.scss"

interface Props {
    assignmentSubmission: AssignmentSubmissionResponse
    lessonSubmission: LessonSubmissionResponse
    topicSubmission: TopicSubmissionResponse
    assessmentSubmission: AssessmentSubmissionResponse
    assessmentOnly: boolean
    openSubmission: () => void
}

const StudentSubmissionSidebar = ({ assignmentSubmission, lessonSubmission, topicSubmission, assessmentSubmission, assessmentOnly, openSubmission } : Props) => {
    const reworkRequired = assignmentSubmission.status === "rework-required"

  return (
    <Pane className="shadow">
        <>
            {assignmentSubmission.status === "graded" &&
            <div className="d-flex flex-column align-items-center justify-content-center">
                <p className="bg-success text-center text-white fw-bold p-2 rounded w-100"><i className={`fas fa-check`}/> Graded</p>
            </div>}
            {reworkRequired && 
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <p className="bg-info text-center fw-bold p-2 rounded w-100"><i className={`fas fa-repeat`}/> Rework Required</p>
                    <Button variant="primary" onClick={openSubmission}>Open Submission</Button>
                </div>}
            {assignmentSubmission.status === "rejected" && 
            <div className="d-flex flex-column align-items-center justify-content-center">
                <p className="bg-danger text-center text-white fw-bold p-2 rounded w-100"><i className={`fas fa-times`}/> Rejected</p>
            </div>}
        </>
        {!assessmentOnly && <>
            <Label title="Time Taken">{Math.ceil((lessonSubmission?.timeOnTask ?? topicSubmission?.timeOnTask) / 60)} minute</Label>
            <Label title="Overall Grade">{reworkRequired ? "---" : `${assignmentSubmission.grade}%`}</Label>
            {lessonSubmission && 
                <Label title="Lesson Grade">
                    {reworkRequired ? "---" : `${lessonSubmission.grade ?? 0}%`}
                </Label>}
        </>}
        {assessmentSubmission && 
            <Label title="Assessment Grade">
                {reworkRequired ? "---" : formatGrade((assessmentSubmission.grade ?? 0).toString())}
            </Label>}
        {lessonSubmission && <>
            <hr />
            <i className="far fa-comment-dots pe-2 pb-2" />
            <strong>Comments</strong>
            <br />
            <textarea
                className={`${styles.commentTextbox} w-100 p-1`}
                disabled={true}
                defaultValue={lessonSubmission?.labComment ?? ""}
            />
        </>}
    </Pane>
  )
}

export default StudentSubmissionSidebar
